import Footer from "./Footer";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/20/solid";

const AbsorbSupportInfoES = () => {

const generalFaqs = [
    {
        question: "Me gustaría saber más sobre la nueva plataforma y los últimos cambios",
        answer: (
            <>Visita <a href="https://www.meted.ucar.edu/updates" className="text-blue-600 underline cursor-pointer">https://www.meted.ucar.edu/updates</a> para obtener la información más reciente sobre la nueva plataforma, y detalles sobre los cambios y mejoras.</>),
    },
    {
        question: "¿Por qué te pedimos que te registres?",
        answer: `Nuestras agencias patrocinadoras apoyan nuestros esfuerzos para ofrecer capacitación en línea de forma gratuita y nos han pedido que COMET® recopile mejores estadísticas de uso. La mejor manera de desarrollar esta información y mejorar nuestros servicios es implementar un sistema de registro obligatorio. Todos en COMET® agradecemos tu cooperación y apoyo.`,
    },
    {
        question: "¿MetEd es seguro?",
        answer: (
            <>
                Usamos Absorb Software Inc. como nuestro proveedor de servicios de gestión de aprendizaje. Para más información sobre cómo protegen los datos, consulta <a href="https://www.absorblms.com/support/compliance/soc-2/" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">aquí</a>.
            </>
        ),
    },
    {
        question: "¿Qué harán con mi información?",
        answer: `Por motivos de privacidad, solicitamos la mínima información necesaria: nombre y apellido, correo electrónico, contraseña, afiliación organizacional y el país en el que resides. Esta información se utiliza para la gestión de cuentas, soporte al usuario y para generar informes estadísticos anónimos sobre nuestra base de usuarios. Los datos de usuario se reportarán a los patrocinadores de COMET solo de forma agregada, sin identificar información personal, a menos que nos hayas dado tu permiso explícito marcando "Permitir que mi organización vea mis resultados" durante el registro. Este permiso permite que tu organización acceda a tus cursos completados y puntajes de exámenes.`,
    },
    {
        question: "¿Este servicio es gratuito?",
        answer: `Sí. Debes registrarte para usar nuestros materiales, pero no tiene ningún costo y es un proceso muy sencillo. Una vez registrado, tienes acceso a toda nuestra biblioteca de contenidos.`,
    },
    {
        question: "¿Puedo recibir créditos universitarios por los cursos de COMET?",
        answer: `COMET® MetEd no ofrece cursos universitarios ni créditos de ningún tipo. Nuestros cursos se utilizan ampliamente en universidades y algunas organizaciones, como la Sociedad Meteorológica Americana, otorgan créditos de educación continua por completar cursos; sin embargo, nada de esto se administra a través de nuestro programa.`,
    },    
    
];

const accountFaqs = [
    {
        question: "Olvidé mi contraseña",
        answer: (
            <>
                Para solicitar una nueva contraseña, haz clic en el enlace "¿Olvidaste tu contraseña?" que se encuentra debajo del botón de inicio de sesión. Tu nombre de usuario es la dirección de correo electrónico que usaste para registrarte. MetEd ya no permite usar un nombre de usuario diferente a tu correo electrónico.
            </>
        ),
    },
    {
        question: "No recibí un correo electrónico para verificar mi cuenta",
        answer: (
            <>
            Si no recibiste un correo electrónico esperado (como la verificación de cuenta), verifica tu carpeta de spam o correo no deseado; puede haber sido filtrado allí. Estos correos electrónicos son enviados desde noreply@myabsorb.com. Para evitar esto en el futuro:
            <ul className="list-disc pl-6">
                <li>Agrega <strong>noreply@myabsorb.com</strong> a tus contactos de correo electrónico o lista de remitentes seguros.</li>
                <li>Si estás utilizando un correo electrónico de trabajo o institucional, pide a tu departamento de TI que incluya esa dirección en la lista blanca.</li>
            </ul>
            ¿Aún no puedes encontrarlo? Contáctanos en <a href="mailto:lms_support@meted.ucar.edu" className="text-blue-600 underline">lms_support@meted.ucar.edu</a> para obtener ayuda.
            </>
        ),
    },
    {
        question: "¿Puedo cambiar mi afiliación organizacional después de registrarme?",
        answer: (
            <>
                Ya no admitimos cambios en tu afiliación organizacional después de la registración inicial. Si necesitas usar una afiliación diferente, deberás crear una nueva cuenta utilizando una dirección de correo electrónico diferente. Ten en cuenta que las cuentas no se pueden fusionar y permanecerán separadas.
            </>
        ),
    }
];

const usingMetedFaqs = [
    {
        question: "No encuentro una versión imprimible del curso",
        answer: `Ya no ofrecemos una versión descargable o imprimible del contenido de nuestros cursos.`,
    },
];

const quizFaqs = [
    {
        question: "Compartir puntajes de exámenes",
        answer: (
            <>
                Los puntajes de los exámenes se incluirán en tus correos de finalización de curso y puedes compartirlos con quien desees. Esto incluye a tu instructor o supervisor, ya que ellos ya no recibirán automáticamente los puntajes como ocurría en la plataforma anterior.
            </>
        ),
    },
    {
        question: "Salí del examen antes de terminarlo",
        answer: (
            <>
                Todas las respuestas se guardan a medida que completas cada pregunta; sin embargo, al volver a ingresar al examen, las preguntas pueden aparecer en un orden diferente. Las preguntas guardadas tendrán una marca de verificación junto a ellas.
            </>
        ),
    }
];

const certificateFaqs = [
    {
        question: "¿Cómo define MetEd un curso completado?",
        answer: (
            <>
                Cuando hayas completado con éxito las secciones básicas requeridas del curso: el contenido, el examen y la encuesta.
            </>
        ),
    },
    {
        question: "¿Cómo encuentro mi certificado?",
        answer: (
            <>
                <ul className="list-disc pl-6">
                    <li>Inicia sesión en MetEd y ve a “Transcripción”</li>
                    <li>Busca el curso que completaste y haz clic en el botón “Descargar” junto a él</li>
                    <li>Se descarga como PDF y puedes imprimirlo o compartirlo</li>
                    <li><strong>Nota:</strong> Si no hay botón de descarga, el curso no está completamente terminado — vuelve al curso y completa todas las secciones requeridas.</li>
                </ul>
            </>
        ),
    },
    {
        question: "No puedo imprimir mi certificado",
        answer: (
            <>
                Los certificados están disponibles como archivos PDF. Debes tener un visor de PDF instalado para ver e imprimir los certificados.
            </>
        ),
    }
];

const subscriptionsFaqs = [
    {
        question: "Como me doy de baja de los correos electrónicos de MetEd?",
        answer: `Haz clic en el enlace "Darse de baja" al final de cualquier correo electrónico que recibas de nosotros.`,
    },
];

const contactUsFaqs = [
    {
        question: "¿Cómo puedo contactarlos?",
        answer: (
            <>
                <div className="bg-yellow-100 p-4 mb-4">
                <p className="font-bold">Si tienes problemas para iniciar sesión:</p>
                <p>Ten en cuenta que MetEd se trasladó a una nueva plataforma el 2 de junio de 2025. Las credenciales de inicio de sesión del sistema anterior ya no son válidas. Para continuar en la nueva plataforma, crea una nueva cuenta aquí: <a href="https://learn.meted.ucar.edu/#/public-dashboard" className="text-blue-600 underline">https://learn.meted.ucar.edu/#/public-dashboard</a>.</p>
                <br />
                <p className="font-bold"> Si necesitas tus archivos de la plataforma anterior de MetEd:</p>
                <p>Aún puedes descargar tu expediente, certificados y lista de lecciones de la plataforma anterior aquí: <a href="https://www.meted.ucar.edu/transcripts" className="text-blue-600 underline">https://www.meted.ucar.edu/transcripts</a>.</p>
                <br />
                <p className="font-bold">Para preguntas de soporte:</p>
                <p>Envíanos un correo electrónico a <a href="mailto:lms_support@meted.ucar.edu" className="text-blue-600 underline">lms_support@meted.ucar.edu</a>.</p>
                <br />
                <p className="font-bold">Para obtener información sobre el uso de nuestros recursos visuales (gráficos, videos, etc.):</p>
                <p>consulta nuestros <a href="https://www.meted.ucar.edu/legal" className="text-blue-600 underline">Términos de Uso del Sitio</a>.</p>
                </div>
            </>
        ),
    },
];

return (
    <div>
        <main className="mb-24">
            <div className="relative py-24 sm:py-20">
                <div className="mx-auto max-w-7xl px-3 lg:px-8">
                    <div className="mx-auto text-center">
                        <h1 className="text-4xl font-bold tracking-tight text-gray-900">
                            Ayuda y Preguntas Frecuentes
                        </h1>
                    </div>
                </div>
            </div>
            <div className="mx-auto max-w-7xl px-4">
                <h3 className="text-2xl font-semibold text-gray-700 mb-6 border-t border-gray-200 pt-4">
                    Información General
                </h3>
                <div className="space-y-4 mb-4">
                    <Disclosure defaultOpen={true}>
                        {({ open }) => (
                        <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                            <span>Terminología Anterior vs. Actual</span>
                            <ChevronDownIcon
                                className={`${
                                    open ? "rotate-180 transform" : ""
                                } h-8 w-8 text-white`}
                            />
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                            MetEd actualizó recientemente la terminología en su plataforma para reflejar mejor la estructura y el propósito de su contenido educativo:
                                <table className="divide-y divide-gray-200 mx-auto my-4 w-full max-w-2xl text-center">
                                    <thead>
                                        <tr>
                                            <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 outline outline-1 outline-gray-200">Terminología Anterior</th>
                                            <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 outline outline-1 outline-gray-200">Terminología Actual</th>
                                            <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 outline outline-1 outline-gray-200">Definición</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 outline outline-1 outline-gray-200 text-left">
                                        <tr>
                                            <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-700 border border-gray-200">Lección</td>
                                            <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-700 border border-gray-200">Curso</td>
                                            <td className="whitespace-wrap px-6 py-2 text-sm text-gray-700 border border-gray-200">Contenido dirigido sobre un tema específico</td>
                                        </tr>
                                        <tr>
                                            <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-700 border border-gray-200">Curso</td>
                                            <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-700 border border-gray-200">Currículo</td>
                                            <td className="whitespace-wrap px-6 py-2 text-sm text-gray-700 border border-gray-200">Una colección de cursos centrados en un tema o área más amplia</td>
                                        </tr>
                                    </tbody>
                                </table>
                        </Disclosure.Panel>
                        </>
                    )}
                    </Disclosure>
                </div>
                
                <div className="space-y-4">
                    {generalFaqs.map((faq, idx) => (
                        <Disclosure key={idx}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>

                <h3 className="text-2xl font-semibold text-gray-700 my-6 border-t border-gray-200 pt-4">
                    Problemas de Inicio de Sesión y Cuenta de Usuario
                </h3>
                <div className="space-y-4">
                    {accountFaqs.map((faq, idx) => (
                        <Disclosure key={idx}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>

                <h3 className="text-2xl font-semibold text-gray-700 my-6 border-t border-gray-200 pt-4">
                    Uso de los Cursos de MetEd
                </h3>
                <div className="space-y-4">
                    {usingMetedFaqs.map((faq, idx) => (
                        <Disclosure key={idx}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>

                <h3 className="text-2xl font-semibold text-gray-700 my-6 border-t border-gray-200 pt-4">
                    Problemas con los Exámenes
                </h3>
                <p className="mb-2"><strong>Importante:</strong> Volver a tomar un examen borrará tu puntaje anterior SOLO si obtienes una calificación más alta.</p>
                <div className="space-y-4">
                    {quizFaqs.map((faq, idx) => (
                        <Disclosure key={idx}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>

                <h3 className="text-2xl font-semibold text-gray-700 my-6 border-t border-gray-200 pt-4">
                    Problemas con los Certificados
                </h3>
                <div className="space-y-4">
                    {certificateFaqs.map((faq, idx) => (
                        <Disclosure key={idx}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>

                <h3 className="text-2xl font-semibold text-gray-700 my-6 border-t border-gray-200 pt-4">
                    Suscripciones
                </h3>
                <div className="space-y-4">
                    {subscriptionsFaqs.map((faq, idx) => (
                        <Disclosure key={idx}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>

                <h3 className="text-2xl font-semibold text-gray-700 my-6 border-t border-gray-200 pt-4">
                    Contáctanos
                </h3>
                <div className="space-y-4">
                    {contactUsFaqs.map((faq, idx) => (
                        <Disclosure key={idx} defaultOpen>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-[#1a658f] px-4 py-3 text-left text-lg font-medium text-white hover:bg-[#007fa3] focus:outline-none focus-visible:ring focus-visible:ring-blue-500/75">
                                        <span>{faq.question}</span>
                                        <ChevronDownIcon
                                            className={`${
                                                open ? "rotate-180 transform" : ""
                                            } h-8 w-8 text-white`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-4 pt-2 text-gray-700 text-base">
                                        {faq.answer}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>
            </div>
        </main>
        <Footer />
    </div>
);
};

export default AbsorbSupportInfoES;
